import * as Flowbite from 'flowbite-react';
import { RefObject } from 'react';
import { BaseInputProps } from '../types';
import { theme } from './theme';

type FlowbiteProps = Pick<
    Flowbite.TextInputProps,
    'sizing' | 'icon' | 'rightIcon'
>;

// TODO: forwardRef to all inputs, not just TextInput
type TextProps = BaseInputProps &
    FlowbiteProps & { ref?: RefObject<HTMLInputElement | null> };

export const TextInput = ({
    onChange = () => {},
    label,
    color = 'primary',
    value,
    ref,
    ...props
}: TextProps) => (
    <Flowbite.Label className="flex flex-col gap-2 font-normal" color={color}>
        {label && <span className="font-medium">{label}</span>}

        <Flowbite.TextInput
            theme={theme}
            {...props}
            value={value || ''}
            ref={ref}
            color={color}
            onChange={(e) => onChange(e.target.value)}
        />
    </Flowbite.Label>
);
TextInput.displayName = 'TextInput';
